module.exports = __webpack_public_path__ + "img/zx7.2dfa4587.png";